import sharedErrors from './errors.json';
import sharedLabels from './labels.json';

// Export shared strings (imported from JSON)
export const SHARED_ERRORS = sharedErrors;
export const SHARED_LABELS = sharedLabels;

// Type exports for consumption
export type SharedErrorKey = keyof typeof sharedErrors;
export type SharedLabelKey = keyof typeof sharedLabels;
